import {catalogItemId} from './catalogItemId';

const KEY = 'luticaGuestCart';

/** @typedef {{ itemId: number, itemCount: number, title?: string, price?: number, count?: number }} GuestCartLine */

export function readGuestCart() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function writeGuestCart(/** @type {GuestCartLine[]} */ lines) {
    localStorage.setItem(KEY, JSON.stringify(lines));
}

export function addToGuestCart(item, delta = 1) {
    const lines = readGuestCart();
    const pid = catalogItemId(item);
    if (pid == null) {
        return lines;
    }
    const idx = lines.findIndex((x) => x.itemId === pid);
    const max = item.count ?? 0;
    if (idx >= 0) {
        const next = Math.min(max, Math.max(0, lines[idx].itemCount + delta));
        if (next <= 0) lines.splice(idx, 1);
        else {
            lines[idx].itemCount = next;
            lines[idx].title = item.title;
            lines[idx].price = Number(item.price);
            lines[idx].count = max;
        }
    } else if (delta > 0 && max > 0) {
        lines.push({
            itemId: pid,
            itemCount: Math.min(max, delta),
            title: item.title,
            price: Number(item.price),
            count: max,
        });
    }
    writeGuestCart(lines);
    return lines;
}

export function clearGuestCart() {
    localStorage.removeItem(KEY);
}

export function guestCartToOrderItemRequests(lines) {
    return lines.map((l) => ({ itemId: l.itemId, itemCount: l.itemCount }));
}
